import { PerformOcrResult, handleImageInput, withSBErrorHandling } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotOcrEngineImpl = {
    async recognizeOnImages(params) {
        return withSBErrorHandling(async () => new PerformOcrResult(await ScanbotSDKPlugin.recognizeOcrOnImages({
            configuration: params.configuration,
            images: handleImageInput(params.images),
        })));
    },
    async recognizeOnDocument(params) {
        return withSBErrorHandling(async () => new PerformOcrResult(await ScanbotSDKPlugin.recognizeOcrOnDocument(params)));
    },
};
//# sourceMappingURL=OcrEngineImpl.js.map